import * as actionTypes from './actionTypes';

export const getUser = token => ({
  type: actionTypes.GET_USER,
  token,
});

export const getUserStart = () => ({
  type: actionTypes.GET_USER_START,
});

export const getUserSuccess = user => ({
  type: actionTypes.GET_USER_SUCCESS,
  user,
});

export const getUserFail = userError => ({
  type: actionTypes.GET_USER_FAIL,
  userError,
});

export const clearUser = () => ({
  type: actionTypes.CLEAR_USER,
});

export const getUserTags = () => ({
  type: actionTypes.GET_USER_TAGS,
});

export const getUserTagsSuccess = tags => ({
  type: actionTypes.GET_USER_TAGS_SUCCESS,
  tags,
});

export const getUserTagsError = () => ({
  type: actionTypes.GET_USER_TAGS_ERROR,
});

export const setUserEmail = email => ({
  type: actionTypes.SET_USER_EMAIL,
  email,
});

export const setUser = user => ({
  type: actionTypes.SET_USER,
  user,
});
